import { motion } from "framer-motion";

export const ImpactSection = () => {
  return (
    <section data-testid="impact-section" className="bg-[#0A0A0A] text-white py-28 md:py-40">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="label-editorial text-clay-soft mb-10"
        >
          Projeto Mudança de Visual
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="font-display text-4xl sm:text-5xl lg:text-7xl leading-[1.05] tracking-tight max-w-4xl"
        >
          Só tem uma oportunidade para criar a{" "}
          <span className="italic text-clay-soft">primeira impressão</span>.
        </motion.h2>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-12"
        >
          <a
            href="#marcacoes"
            data-testid="impact-cta"
            className="label-editorial border border-white/30 px-8 py-4 inline-block hover:bg-white hover:text-black transition-colors duration-300"
          >
            Mudar de Visual
          </a>
        </motion.div>
      </div>
    </section>
  );
};
